'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var Glyph = function Glyph(props) {
    var className = (0, _classnames2['default'])('GlyphIcon', 'vx_icon', 'vx_' + props.icon, props.size ? 'vx_icon-' + props.size : 'vx_icon-small', props.type ? 'GlyphIcon__color--' + props.type : null, props.className);
    var rest = (0, _blacklist2['default'])(props, 'className', 'icon', 'type', 'size');

    return _react2['default'].createElement('span', _extends({ className: className }, rest));
};

Glyph.propTypes = {
    className: _propTypes2['default'].string,
    icon: _propTypes2['default'].string,
    size: _propTypes2['default'].oneOf(['small', 'medium', 'large', 'default']),
    type: _propTypes2['default'].oneOf(['error', 'default', 'primary', 'success', 'warning', 'danger', 'muted'])
};

module.exports = Glyph;